import "core-js/modules/es.symbol";
import "core-js/modules/es.symbol.description";
import "core-js/modules/es.symbol.iterator";
import "core-js/modules/es.array.iterator";
import "core-js/modules/es.object.to-string";
import "core-js/modules/es.regexp.to-string";
import "core-js/modules/es.string.iterator";
import "core-js/modules/web.dom-collections.iterator";

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance"); }

function _iterableToArrayLimit(arr, i) { if (!(Symbol.iterator in Object(arr) || Object.prototype.toString.call(arr) === "[object Arguments]")) { return; } var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import React, { useState, useRef, useEffect } from "react";
import classnames from "classnames";
import { useDragScroll } from "web/react/hooks/use-drag-scroll/use-drag-scroll";
import styles from "./drag-rail.css";
export var PREVENT_CLICK_TOLERANCE = 10;

function DragRail(_ref) {
  var id = _ref.id,
      _ref$onDragStart = _ref.onDragStart,
      onDragStart = _ref$onDragStart === void 0 ? function () {} : _ref$onDragStart,
      className = _ref.className,
      _ref$dragSpeed = _ref.dragSpeed,
      dragSpeed = _ref$dragSpeed === void 0 ? 2 : _ref$dragSpeed,
      children = _ref.children;

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      isMouseDown = _useState2[0],
      setIsMouseDown = _useState2[1];

  var scrollingDiv = useRef(null);

  var _useDragScroll = useDragScroll(scrollingDiv, dragSpeed),
      _useDragScroll2 = _slicedToArray(_useDragScroll, 2),
      startDrag = _useDragScroll2[0],
      endDrag = _useDragScroll2[1];

  function handleMouseDown(e) {
    e.preventDefault();
    setIsMouseDown(true);
  }

  function handleMouseUp() {
    setIsMouseDown(false);
  }

  useEffect(function () {
    function handleClick(e) {
      // If the user drags more than this amount of pixels then cancel click events
      if (Math.abs(startDrag - endDrag) > PREVENT_CLICK_TOLERANCE) {
        e.preventDefault();
        e.stopPropagation();
        onDragStart();
      }
    }

    if (!scrollingDiv.current) {
      return;
    }

    var domNode = scrollingDiv.current;

    if (domNode) {
      // N.b Mouse events for baustein components are not captured by react
      // Native handler is required here capture mouse events on e.g. ProductCard components
      domNode.addEventListener("click", handleClick, true);
    }

    return function () {
      if (domNode) {
        domNode.removeEventListener("click", handleClick, true);
      }
    };
  }, [startDrag, endDrag, onDragStart]);
  return React.createElement("div", {
    className: classnames(styles.hideScrollBar, className)
  }, React.createElement("div", {
    id: id,
    className: styles.dragRailOuterContainer,
    ref: scrollingDiv,
    onMouseDown: handleMouseDown,
    onMouseUp: handleMouseUp,
    onMouseLeave: handleMouseUp
  }, React.createElement("div", {
    className: classnames(styles.dragRailInnerContainer, _defineProperty({}, styles.grabbing, isMouseDown))
  }, children)));
}

export default DragRail;